<template>
  <LoginCard
    data-test-id="UserLogin__PasswordEntry"
  >
    <h1 :class="$style.header">
      User Login
    </h1>
    <LoginAlert
      centered
      v-model="errorMessage"
    >
      <div v-if="errorMessage">
        {{ errorMessage }}
        <div>
          <span>Are you trying to </span>
          <a
            :class="$style.swapClientTypeLink"
            data-test-id="UserLogin__PasswordEntry__adminLink"
            @click="goToAdminLogin"
          >
            log in as an Administrator?
          </a>
        </div>
      </div>
    </LoginAlert>
    <form
      :action="submit"
      autocomplete="on"
      method="post"
    >
      <LoginTextField
        autoFocus
        label="Password"
        name="password"
        placeholder="Password"
        required
        :submitOnEnter="submit"
        type="password"
        vvName="password"
        v-model="form.password"
      />
      <LoginActionButton
        :action="submit"
        data-automation="loginButton"
        :isLoading="isLoading"
        type="submit"
      >
        Login
      </LoginActionButton>
    </form>
    <div
      :class="$style.resetPassword"
      data-test-id="UserLogin__PasswordEntry__resetPasswordLink"
    >
      <span
        :class="$style.resetPasswordLink"
        @click="resetPasswordRequest"
      >
        Reset User Password
      </span>
    </div>
  </LoginCard>
</template>
<script>
import { LoginConsts } from 'client/util/Constants';
import LoginActionButton from 'client/components/LoginActionButton.vue';
import LoginAlert from 'client/components/LoginAlert.vue';
import LoginCard from 'client/components/LoginCard.vue';
import LoginTextField from 'client/components/LoginTextField.vue';
import api from 'client/api';

const {
  clientType,
} = LoginConsts;
const { user } = clientType;
const userApi = api[user];

export default {
  name: 'PasswordEntry',

  userApi,

  components: {
    LoginActionButton,
    LoginAlert,
    LoginTextField,
    LoginCard,
  },

  props: {
    errorMessage: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    goToAdminLogin: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  methods: {
    getCredentials() {
      const { email, password } = this.form;

      return { email, password };
    },

    resetPasswordRequest() {
      this.$emit('resetPasswordRequest');
    },

    submit() {
      this.isLoading = true;

      return this.$options.userApi.login(this.getCredentials())
        .then(response => this.$emit('success', response))
        .catch(error => this.$emit('error', error))
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style module>
@import '../../css/login-components.css';

.container {
  padding: 1rem;
}
</style>
